import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets the seller affidavit on public view.
 */
export const getSellerAffidavit = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v3/socios-sociedades/declaracion-jurada/${normalizeDniSlashes(dni)}`)
})
